import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useOutletContext } from "react-router-dom";
import { adminApi } from "../../services/api";
import AdminPanel from "../../components/admin/AdminPanel";
import AdminTable from "../../components/admin/AdminTable";
import useAdminData from "../../components/admin/useAdminData";
import { unwrap, params, formatDate } from "../../components/admin/adminFormat";

export default function Transactions() {
  const { t } = useTranslation();
  const { locale } = useOutletContext();
  const [status, setStatus] = useState("");
  const { data, loading } = useAdminData(async () => unwrap(await adminApi.getTransactions(params({ status }))), [status]);
  const items = data || [];

  return (
    <AdminPanel>
      <select value={status} onChange={(event) => setStatus(event.target.value)}>
        <option value="">{t("admin.all")}</option>
        <option value="EN_ATTENTE_PARTIE2">EN_ATTENTE_PARTIE2</option>
        <option value="CONFIRME">CONFIRME</option>
        <option value="REFUSE">REFUSE</option>
      </select>
      {loading ? t("common.loading") : (
        <AdminTable
          t={t}
          headers={[t("admin.reference"), t("admin.type"), t("admin.status"), t("admin.amount"), t("admin.date")]}
          rows={items.map((item) => [item.reference, item.transactionType, item.status, item.declaredAmount ?? "—", formatDate(item.createdAt, locale)])}
        />
      )}
    </AdminPanel>
  );
}
